// Types e constants compartilhados pelos sub-componentes de Contas a Pagar.
// Extraído de FinanceiroContasPagar.tsx durante refactor topológico (F-CP-refactor-split).

export interface CentroCustoItem {
  centro: string | null;
  valor: number;
  categoria_dre?: string;
  grupo_dre?: string;
  cc_contrato_numero?: string;
  cc_contrato_titulo?: string;
  clockify_project_id?: string;
  clockify_project_nome?: string;
  horas_seg?: number;
}

export interface ContaPagar {
  id: string;
  origem: 'upload_xlsx' | 'manual' | 'conta_azul_api';
  // _fonte: tabela real da linha (lancamentos_pagar × lancamentos_manuais).
  // Necessário pra rotear delete/patch: despesa manual do CP tem origem='manual'
  // mas mora em lancamentos_pagar — origem sozinha não distingue das manuais.
  _fonte?: 'lancamentos_pagar' | 'lancamentos_manuais';
  data_competencia: string | null; periodo: string;
  descricao: string | null; fornecedor: string | null;
  categoria_dre: string | null; grupo_dre: string | null;
  valor: number; status: 'pago' | 'em_aberto' | 'agendado' | 'cancelado';
  data_vencimento: string | null;
  data_pagamento: string | null; data_pagamento_real?: string | null;
  nota_fiscal_numero: string | null; meio_pagamento: string | null;
  observacoes: string | null; criado_em: string;
  diferido: boolean;
  conta_financeira_ca?: string | null; conciliado_ca?: boolean | null;
  // Lista de pagamentos: baixas do Conta Azul (sem `origem`) e, desde
  // 07/10/2026, as partes registradas na tela ('sistema') e o extrato
  // vinculado a um lançamento pago em partes ('extrato').
  baixas_ca?: Array<{
    id?: string;
    origem?: 'sistema' | 'extrato';
    data_pagamento?: string;
    data_informada?: string;          // parte colada ao extrato: a data que a pessoa digitou
    valor_composicao?: { multa?: number; juros?: number; valor_bruto?: number; desconto?: number; taxa?: number; valor_liquido?: number };
    conta_financeira?: { id?: string; nome?: string } | null;
    conta_financeira_id?: string | null;
    transacao_id?: string;
    substitui?: Array<{ valor_composicao?: { valor_bruto?: number; valor_liquido?: number }; data_pagamento?: string; conta_financeira?: { nome?: string } | null }>;
    metodo_pagamento?: string | null;
    registrado_por?: string | null;
    atualizado_em?: string;
  }> | null;
  valor_pago?: number | string | null;
  credito_combustivel?: boolean;   // crédito do cartão Ticket Log (o rateio sai das notas em Combustíveis)
  centros_custo?: CentroCustoItem[] | null;
  rateado_clockify?: boolean;
  fornecedor_id?: string | null;
  emissor?: string | null;        // loja/estabelecimento (reembolso); geralmente vazio nos demais CPs
  emissor_cnpj?: string | null;
}

export const STATUS_CP: Record<string, { tagColor: string; label: string }> = {
  pago:        { tagColor: 'success', label: 'Pago' },
  agendado:    { tagColor: 'processing', label: 'Agendado' },
  em_aberto:   { tagColor: 'gold',    label: 'Em aberto' },
  cancelado:   { tagColor: 'default', label: 'Cancelado' },
};

export type SortDir = 'asc' | 'desc';
export type ModoData = 'vencimento' | 'pagamento' | 'competencia';

// F-CP-refactor: removidas as colunas separadas de "fornecedor" e "categoria"
// — agora aparecem como tags abaixo do "Resumo" (estilo CA). A busca textual
// continua cobrindo esses campos. "acoes" é coluna nova com o menu dropdown.
// F-CP-totais: colunas separadas "Total" (valor bruto) × "A pagar" (saldo
// devedor após baixas parciais) — alinha com layout do Conta Azul.
export type ColunaKeyCP = 'data' | 'data_sec' | 'descricao' | 'origem' | 'status' | 'valor' | 'a_pagar' | 'acoes';
export const COLUNAS_DEFAULT_CP: ColunaKeyCP[] = ['data', 'data_sec', 'descricao', 'origem', 'valor', 'a_pagar', 'status', 'acoes'];
export const LS_KEY_ORDEM_COLUNAS_CP = 'fin_cp_ordem_colunas_v3';  // bump pra ignorar layout antigo
export const LS_KEY_ORDENACAO_CP = 'fin_cp_ordenacao_v1';
export const COLUNAS_SORTAVEIS_CP: ColunaKeyCP[] = ['data', 'descricao', 'origem', 'status', 'valor', 'a_pagar'];
export const ORDEM_STATUS_CP: Record<string, number> = { em_aberto: 0, agendado: 1, pago: 2, cancelado: 3 };
